export default function(value, decimalPlaces) {
	value = value || 0;
	decimalPlaces = decimalPlaces != undefined ? decimalPlaces : 2;

	return `R$ ${value.toLocaleString('pt-br', { 
		minimumFractionDigits: decimalPlaces, 
		maximumFractionDigits: decimalPlaces
	})}`;
}